import { Component } from "react";
import "../assets/css/carousel.css";

class Carousel extends Component {
    state = {
        items: [],
        index: 0,
        loading: true,
        error: null,
        autoplay: true
    };

    interval = null;

    componentDidMount() {
        fetch("https://musashijj.cl/login/admin/landing/api/getCarrusel.php")
            .then((res) => {
                if (!res.ok) throw new Error("Error al obtener las imágenes.");
                return res.json();
            })
            .then((data) => {
                let items = data?.carrusel || [];

                items.sort((a, b) => {
                    const numA = parseInt(a.number ?? 0, 10);
                    const numB = parseInt(b.number ?? 0, 10);
                    return numA - numB;
                });

                this.setState({ items, loading: false }, this.startAutoplay);
            })
            .catch((error) => this.setState({ error, loading: false }));
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    startAutoplay = () => {
        this.interval = setInterval(() => {
            if (this.state.autoplay) {
                this.next();
            }
        }, 4000);
    };

    next = () => {
        this.setState((prev) => ({
            index: (prev.index + 1) % prev.items.length
        }));
    };

    prev = () => {
        this.setState((prev) => ({
            index:
                (prev.index - 1 + prev.items.length) %
                prev.items.length
        }));
    };

    goTo = (i) => {
        this.setState({ index: i });
    };

    render() {
        const { items, index, loading, error } = this.state;

        if (loading) return <div>Cargando carrusel...</div>;
        if (error) return <div>Error: {error.message}</div>;
        if (!items.length) return <div>No hay imágenes.</div>;

        return (
            <div
                className="carousel"
                onMouseEnter={() => this.setState({ autoplay: false })}
                onMouseLeave={() => this.setState({ autoplay: true })}
            >
                <div
                    className="carousel-track"
                    style={{
                        transform: `translateX(-${index * 100}%)`
                    }}
                >
                    {items.map((item, i) => (
                        <div className="carousel-slide" key={i}>
                            <img
                                src={item.pathname}
                                alt={`slide-${i}`}
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                    ))}
                </div>

                <button aria-label="Desplazar carrusel hacia la izquierda" className="carousel-btn prev" onClick={this.prev}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-left-fill" viewBox="0 0 16 16">
                        <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
                    </svg>
                </button>

                <button aria-label="Desplazar carrusel hacia la derecha" className="carousel-btn next" onClick={this.next}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16">
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                    </svg>
                </button>

                <div className="carousel-dots">
                    {items.map((_, i) => (
                        <span
                            key={i}
                            className={i === index ? "dot active" : "dot"}
                            onClick={() => this.goTo(i)}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

export default Carousel;
